import consoleLog from "@/utils/consoleLog";
import toastUtils from "@/utils/toastUtils";

/**
 * 引入 Axios
 * @type {axios.AxiosStatic | axios | AxiosStatic | {AxiosResponseTransformer: AxiosResponseTransformer, AxiosRequestConfig: AxiosRequestConfig, AxiosResponseHeaders: RawAxiosResponseHeaders & AxiosHeaders, CanceledError: CanceledError, TransitionalOptions: TransitionalOptions, CancelTokenStatic: CancelTokenStatic, formToJSON(form: (GenericFormData | GenericHTMLFormElement)): object, LookupAddress: string | LookupAddressEntry, HttpStatusCode: HttpStatusCode, FormSerializerOptions: FormSerializerOptions, Axios: Axios, AddressFamily: 4 | 6, all<T>(values: Array<Promise<T> | T>): Promise<T[]>, getAdapter(adapters: (AxiosAdapterConfig | AxiosAdapterConfig[] | undefined)): AxiosAdapter, FormDataVisitorHelpers: FormDataVisitorHelpers, responseEncoding: "ascii" | "ASCII" | "ansi" | "ANSI" | "binary" | "BINARY" | "base64" | "BASE64" | "base64url" | "BASE64URL" | "hex" | "HEX" | "latin1" | "LATIN1" | "ucs-2" | "UCS-2" | "ucs2" | "UCS2" | "utf-8" | "UTF-8" | "utf8" | "UTF8" | "utf16le" | "UTF16LE", AxiosInterceptorOptions: AxiosInterceptorOptions, toFormData(sourceObj: object, targetFormData?: GenericFormData, options?: FormSerializerOptions): GenericFormData, Method: "get" | "GET" | "delete" | "DELETE" | "head" | "HEAD" | "options" | "OPTIONS" | "post" | "POST" | "put" | "PUT" | "patch" | "PATCH" | "purge" | "PURGE" | "link" | "LINK" | "unlink" | "UNLINK", LookupAddressEntry: LookupAddressEntry, ResponseType: "arraybuffer" | "blob" | "document" | "json" | "text" | "stream" | "formdata", AxiosHeaders: AxiosHeaders, AxiosProgressEvent: AxiosProgressEvent, AxiosStatic: AxiosStatic, SerializerOptions: SerializerOptions, AxiosRequestTransformer: AxiosRequestTransformer, GenericAbortSignal: GenericAbortSignal, RawAxiosResponseHeaders: RawAxiosResponseHeaders, isAxiosError<T=any, D=any>(payload: any): payload is AxiosError<T, D>, AxiosHeaderValue: AxiosHeaders | string | string[] | number | boolean, AxiosRequestHeaders: RawAxiosRequestHeaders & AxiosHeaders, ParamsSerializerOptions: ParamsSerializerOptions, Canceler: Canceler, Cancel: Cancel, AxiosResponse: AxiosResponse, AxiosProxyConfig: AxiosProxyConfig, RawAxiosRequestHeaders: RawAxiosRequestHeaders, AxiosInstance: AxiosInstance, CancelTokenSource: CancelTokenSource, SerializerVisitor: SerializerVisitor, GenericFormData: GenericFormData, CreateAxiosDefaults: CreateAxiosDefaults, GenericHTMLFormElement: GenericHTMLFormElement, CancelToken: CancelToken, isCancel(value: any): value is Cancel, AxiosDefaults: AxiosDefaults, AxiosPromise: Promise<AxiosResponse<T>>, spread<T, R>(callback: (...args: T[]) => R): (array: T[]) => R, RawAxiosRequestConfig: AxiosRequestConfig<D>, InternalAxiosRequestConfig: InternalAxiosRequestConfig, HeadersDefaults: HeadersDefaults, AxiosInterceptorManager: AxiosInterceptorManager, ParamEncoder: ParamEncoder, AxiosError: AxiosError, CustomParamsSerializer: CustomParamsSerializer, AxiosBasicCredentials: AxiosBasicCredentials, CancelStatic: CancelStatic, AxiosAdapter: AxiosAdapter, readonly default: AxiosStatic}}
 */
const axios = require('axios');

/**
 * 创建一个自定义的 Axios 实例
 * @type {axios.AxiosInstance}
 */
const instance = axios.create({
    timeout: 15000, // 设置请求超时时间（单位：毫秒）
    headers: {
        // 设置请求头的 Content-Type
        'Content-Type': 'application/json',
    },
    // 跨域请求时是否需要使用凭证
    withCredentials: false
});

/**
 * 请求拦截器
 */
instance.interceptors.request.use(
    function (config) {
        consoleLog.info("axios request:", config)
        // 在发送请求之前可以在此处对请求进行处理，如添加认证信息、修改请求头等
        return config;
    }, function (error) {
        consoleLog.error("axios request error:", error)
        // 对请求错误进行处理
        return Promise.reject(error);
    }
);

/**
 * 响应拦截器
 */
instance.interceptors.response.use(
    function (response) {
        consoleLog.info("axios response:", response)
        // 对响应数据进行处理
        return response.data;
    }, function (error) {
        consoleLog.error("axios response error:", error)
        // 对响应错误进行处理
        return Promise.reject(error);
    }
);

/**
 * get请求
 * @param url
 * @param data
 * @param callback
 */
const get = (url, data, callback) => {
    instance({
        method: 'get',
        url: url,
        data: data
    }).then((res) => {
        if (callback) {
            callback(res)
        }
    }).catch((err) => {
        if (callback) {
            callback(err)
        }
    })
}

/**
 * post请求
 * @param url
 * @param data
 * @param callback
 */
const post = (url, data, callback) => {
    instance({
        method: 'post',
        url: url,
        data: data
    }).then((res) => {
        if (res.status === 4001 || res.status === 4002) {
            window.globalDoPush("/loginPage")
            toastUtils.warning(window.globalContext, res.msg);
        } else {
            if (callback) {
                callback(res)
            }
        }
    }).catch((err) => {
        if (callback) {
            callback(err)
        }
    })
}

export default {
    get,
    post
}